import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { PageStatus, SearchResultSectionTabs } from '@lean-body/src/view/pages/main_search_result';
import { SearchResultNotFound } from '@lean-body/components/organisms';
import { MoreLoading, SearchLoading } from '@lean-body/components/atoms';
import { PaginationNextButton } from '@lean-body/components/atoms/pagination_next_button';
import { MediaBreakPointUp } from '@lean-body/components/styles';
import { LessonComponent } from '../molecules/lesson_component';
import { useSmMediaQuery } from '@lean-body/src/util';
import { ProgramComponent } from '../molecules/program_component';
import { PlaylistComponentLandscapeImg } from '../molecules';
export const SearchResults = ({ lessons, playlists, seriesPrograms, lessonsCount, seriesProgramsCount, playlistsCount, onClickBack, onClickLesson, onClickProgram, onClickPlaylist, selectedTab, search, lessonsNextButtonDisplayable, playlistsNextButtonDisplayable, seriesProgramsNextButtonDisplayable, pageStatus, isLoadingNext, hideCount, addFavoriteLesson, unFavoriteLesson, addFavoriteProgram, unFavoriteProgram, }) => {
    const isSM = useSmMediaQuery();
    return (React.createElement("div", { className: css(styles.container) }, pageStatus !== PageStatus.InitialPageLoaded ? (React.createElement(SearchLoading, null)) : (React.createElement(React.Fragment, null, selectedTab === SearchResultSectionTabs.lessons ? (React.createElement(React.Fragment, null, lessons.length ? (React.createElement(React.Fragment, null,
        !hideCount && React.createElement("div", { className: css(styles.searchCount) },
            "\u691C\u7D22\u7D50\u679C\uFF1A",
            lessonsCount,
            "\u4EF6"),
        React.createElement("div", { className: css(styles.items) }, lessons.map((lesson, idx) => (React.createElement(LessonComponent, { key: idx, lesson: lesson, addFavoriteLesson: addFavoriteLesson, unFavoriteLesson: unFavoriteLesson, isVertical: !isSM, onClick: onClickLesson })))),
        React.createElement(PaginationNextButton, { classObject: styles.paginationButton, getNextPage: () => search(true), isAvailable: lessonsNextButtonDisplayable }),
        isLoadingNext && React.createElement(MoreLoading, null))) : (React.createElement(SearchResultNotFound, { onClickBack: onClickBack })))) : selectedTab === SearchResultSectionTabs.seriesPrograms ? (React.createElement(React.Fragment, null, seriesPrograms.length ? (React.createElement(React.Fragment, null,
        !hideCount && React.createElement("div", { className: css(styles.searchCount) },
            "\u691C\u7D22\u7D50\u679C\uFF1A",
            seriesProgramsCount,
            "\u4EF6"),
        React.createElement("div", { className: css(styles.items) }, seriesPrograms.map((program) => (React.createElement(ProgramComponent, { key: program.id, program: program, onClick: onClickProgram, addFavoriteProgram: addFavoriteProgram, unFavoriteProgram: unFavoriteProgram, isVertical: !isSM })))),
        React.createElement(PaginationNextButton, { classObject: styles.paginationButton, getNextPage: () => search(true), isAvailable: seriesProgramsNextButtonDisplayable }),
        isLoadingNext && React.createElement(MoreLoading, null))) : (React.createElement(SearchResultNotFound, { onClickBack: onClickBack })))) : (selectedTab === SearchResultSectionTabs.playlists && (React.createElement(React.Fragment, null, playlists.length ? (React.createElement(React.Fragment, null,
        !hideCount && React.createElement("div", { className: css(styles.searchCount) },
            "\u691C\u7D22\u7D50\u679C\uFF1A",
            playlistsCount,
            "\u4EF6"),
        React.createElement("div", { className: css(styles.items) }, playlists.map((playlist, idx) => (React.createElement(PlaylistComponentLandscapeImg, { key: idx, playlist: playlist, addFavoriteProgram: addFavoriteProgram, unFavoriteProgram: unFavoriteProgram, isVertical: !isSM, onClick: onClickPlaylist })))),
        React.createElement(PaginationNextButton, { classObject: styles.paginationButton, getNextPage: () => search(true), isAvailable: playlistsNextButtonDisplayable }),
        isLoadingNext && React.createElement(MoreLoading, null))) : (React.createElement(SearchResultNotFound, { onClickBack: onClickBack })))))))));
};
const styles = StyleSheet.create({
    container: {
        padding: '0 20px',
        [MediaBreakPointUp.MD]: {
            padding: '0 48px',
        },
        [MediaBreakPointUp.XL]: {
            padding: '0 80px',
        },
    },
    searchCount: {
        fontSize: 12,
        fontWeight: 500,
        marginBottom: 12,
    },
    items: {
        display: 'flex',
        gap: '12px 0',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        [MediaBreakPointUp.MD]: {
            gap: '20px 0',
        },
    },
    paginationButton: {
        margin: '20px auto',
        width: 240,
        [MediaBreakPointUp.SM]: {
            margin: '20px auto',
        },
    },
});
